module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icon/car-2cb27a9ec574cd2bea2363ff513f2bc6.svg&quot;;"